import React from 'react';
import { Box, Tooltip as MUIToolTip } from '@mui/material';
import { useTheme } from '@mui/material/styles';

function Tooltip({ icon, ...props }: any) {
  const theme = useTheme();

  return (
    <MUIToolTip
      slotProps={{
        popper: {
          sx: {
            '& .MuiTooltip-tooltip': {
              backgroundColor: theme.palette.background.paper,
              boxShadow: theme.shadows[1],
              padding: theme.spacing(2),
              borderRadius: theme.shape.borderRadius / 2,
            },
          },
        },
      }}
      {...props}
    >
      <Box
        sx={{
          cursor: 'pointer',
          display: 'flex',
        }}
      >
        {icon}
      </Box>
    </MUIToolTip>
  );
}

export default Tooltip;
